<template>
  <el-dialog v-model="insuranceDialogVisiable" width="400">
    <el-form
      ref="insuranceFormRef"
      :rules="insuranceFormRules"
      :model="insuranceForm"
      label-width="auto"
      :size="formSize"
      status-icon
      class="!block mt-2"
      v-if="order"
    >
      <el-form-item :label="t('insuranceCompany')" prop="insurance" required>
        <el-select
          filterable
          clearable
          v-model="insuranceForm.insurance"
          :placeholder="t('insuranceCompanyPlaceholder')"
        >
          <el-option
            v-for="insurance in insurances"
            :key="insurance.id"
            :label="insurance.name"
            :value="insurance.id"
          />
        </el-select>
      </el-form-item>

      <el-form-item :label="t('amountToBePaid')" prop="amountToBePaid">
        <div class="flex gap-1">
          <money-input v-model="insuranceForm.amountToBePaid" currency="IQD" />
          <el-button
            type="primary"
            @click="
              () => {
                insuranceForm.amountToBePaid = totalDue
              }
            "
            >{{ t('payFull') }}</el-button
          >
        </div>
      </el-form-item>
    </el-form>
    <template #footer>
      <div class="dialog-footer">
        <el-button type="primary" @click="submitForm(insuranceFormRef)">
          {{ t('confirm') }}
        </el-button>
        <el-button @click="insuranceDialogVisiable = false">{{ t('close') }}</el-button>
        <el-button @click="clear()">{{ t('clearAmount') }}</el-button>
      </div>
    </template>
  </el-dialog>
  <template v-if="useSettingsStore().getValue('show_insurance_button_on_sales_page') == 'true'">
    <div
      v-if="order"
      class="p-1 bg-gray-100 cursor-pointer"
      :class="{ '!bg-blue-400': order?.invoice.insuranceID }"
      @click="insuranceDialogVisiable = true"
    >
      <img :src="insuranceSvg" class="h-[24px]" alt="" />
    </div>
  </template>
</template>

<script setup lang="ts">
interface InsuranceForm {
  insurance?: string
  amountToBePaid?: number
}

import { ref, onMounted, reactive, watch, nextTick } from 'vue'
import { useI18n } from 'vue-i18n'
import { FormInstance, FormRules, ComponentSize } from 'element-plus'
import MoneyInput from '@/components/form/MoneyInput.vue'
import { useHTTP } from '@/plugins/http'
import Insurance from '@/models/insurance/Insurance'
import { Order } from '@/models/sales/Order'
import insuranceSvg from "@/assets/images/insurance.svg"
import { useSettingsStore } from '@/stores/settingsStore'

const { t } = useI18n({
  useScope: 'global',
  messages: {
    en: {
      insuranceCompany: 'Agency',
      insuranceCompanyPlaceholder: 'Agency name',
      insurancePay: 'Insurance Pay',
      amountToBePaid: 'To pay',
      clearAmount: 'Clear',
      payFull: 'Full'
    },
    ar: {
      payFull: 'دفع كامل',
      insuranceCompany: 'شركة التأمين',
      insuranceCompanyPlaceholder: 'شركة التأمين',
      amountToBePaid: 'تدفع مبلغ',
      clearAmount: 'تفريغ',
      insurancePay: 'يدفع الضامن'
    }
  }
})

const http = useHTTP()
const props = defineProps<{
  order: Order | undefined
}>()

const emit = defineEmits<{
  (e: 'insurance', value: InsuranceForm | undefined): void
}>()

const insurances = ref<Array<Insurance>>([])
const insuranceDialogVisiable = ref(false)
const formSize = ref<ComponentSize>('default')
const insuranceFormRef = ref<FormInstance>()
const insuranceForm = ref<InsuranceForm>({
  insurance: undefined,
  amountToBePaid: 0
})

const insuranceFormRules = reactive<FormRules<InsuranceForm>>({
  insurance: [
    {
      required: true,
      message: t('validation.required'),
      trigger: 'blur'
    }
  ],
  amountToBePaid: [
    {
      required: true,
      trigger: 'change'
    }
  ]
})

watch(() => props.order, (newVal) => {
  nextTick(() => {
    load()
  })
})


const load = async () => {
  try {
    insuranceForm.value.insurance = props.order?.invoice.insuranceID
    insuranceForm.value.amountToBePaid = props.order?.invoice.insuranceTotalDueAmount
    console.log("xxx", insuranceForm.value)
    console.log("xxx", props.order?.invoice.insuranceTotalDueAmount)

    const insurancesResponse = await http.get<Array<Insurance>>(Insurance.ENDPOINT)
    insurances.value = insurancesResponse.map((insurance) => Insurance.from(insurance))
  } catch (e) {
    console.log(e)
  }
}

const submitForm = async (formEl: FormInstance | undefined) => {
  if (!formEl) return
  await formEl.validate((valid, fields) => {
    if (valid) {
      emit('insurance', insuranceForm.value)
      insuranceDialogVisiable.value = false
      console.log(insuranceForm.value)
    } else {
      console.log('error submit!', fields)
    }
  })
}

function clear() {
  insuranceForm.value = {
    insurance: undefined,
    amountToBePaid: 0
  }
  emit('insurance', undefined)
  insuranceDialogVisiable.value = false
}
</script>

<style scoped></style>
